import PsiToolbar from "./PsiToolbar.vue";

export default PsiToolbar;
